import { USER_STATUS_DISPLAY_DEFAULT, USER_STATUS_OPTIONS } from '../../types/sift';

export const BROKER_STATUS_HELP =
  'The broker team’s own workflow status for this VIN — tracked per broker group and '
  + 'independent of the read-only RDS status. Changes are scoped to your group.';

export const BROKER_STATUS_CHOICES: string[] = USER_STATUS_OPTIONS.map(String);
export const BROKER_STATUS_UNSET_LABEL = USER_STATUS_DISPLAY_DEFAULT;

/** §14.8 short display name for the broker who set a status, from their email.
 *  Falls back to the raw email rather than nothing when the local part is all
 *  separators — a hard-to-read identity still beats an anonymous one. */
export function statusSetterName(email?: string | null): string | null {
  const e = (email || '').trim();
  if (!e) return null;
  const local = e.split('@')[0] || e;
  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ') || e;
}
